import { loadState } from '@helpers/localStorage';

export function getSearchParamsFromStorage(storageId: string) {
    const state = loadState(storageId) || {};
    return {
        action: state.action || '',
        searchKey: state.searchKey || '',
        navigationId: state.navigationId || null,
        path: state.path || null,
    };
}
